<script>
import DatePicker from 'vue-datepicker-next';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { parseNaturalSnooze } from 'dashboard/helper/snoozeNaturalLanguage';

export default {
  components: {
    DatePicker,
    NextButton,
  },
  emits: ['close', 'chooseTime'],

  data() {
    return {
      snoozeTime: null,
      naturalText: '',
      nlError: false,
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        yearFormat: 'YYYY',
        monthFormat: 'MMMM',
      },
    };
  },

  computed: {
    nlPreview() {
      if (!this.snoozeTime) return '';
      return format(this.snoozeTime, 'EEEE, d MMM yyyy, HH:mm', {
        locale: ptBR,
      });
    },
  },

  methods: {
    onClose() {
      this.$emit('close');
    },
    onNaturalInput(value) {
      this.naturalText = value;
      if (!value || !value.trim()) {
        this.nlError = false;
        return;
      }
      const parsed = parseNaturalSnooze(value);
      if (parsed) {
        this.snoozeTime = parsed;
        this.nlError = false;
      } else {
        this.snoozeTime = null;
        this.nlError = true;
      }
    },
    onNaturalEnter() {
      if (this.snoozeTime) {
        this.chooseTime();
      }
    },
    chooseTime() {
      this.$emit('chooseTime', this.snoozeTime);
    },
    disabledDate(date) {
      // Disable all the previous dates
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return date < yesterday;
    },
    disabledTime(date) {
      // Allow only time after 1 hour
      const now = new Date();
      now.setHours(now.getHours() + 1);
      return date < now;
    },
  },
};
</script>

<template>
  <div class="flex flex-col">
    <woot-modal-header :header-title="$t('CONVERSATION.CUSTOM_SNOOZE.TITLE')" />
    <form
      class="modal-content w-full pt-2 px-5 pb-6"
      @submit.prevent="chooseTime"
    >
      <input
        :value="naturalText"
        type="text"
        class="w-full mb-1"
        :placeholder="$t('CONVERSATION.CUSTOM_SNOOZE.NL_PLACEHOLDER')"
        :aria-label="$t('CONVERSATION.CUSTOM_SNOOZE.NL_PLACEHOLDER')"
        @input="onNaturalInput($event.target.value)"
        @keydown.enter.prevent="onNaturalEnter"
      />
      <p v-if="nlPreview" class="mb-2 text-sm text-n-teal-11">
        {{ nlPreview }}
      </p>
      <p v-else-if="nlError" class="mb-2 text-sm text-n-ruby-11">
        {{ $t('CONVERSATION.CUSTOM_SNOOZE.NL_INVALID') }}
      </p>
      <DatePicker
        v-model:value="snoozeTime"
        type="datetime"
        inline
        input-class="mx-input "
        :lang="lang"
        :disabled-date="disabledDate"
        :disabled-time="disabledTime"
      />
      <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="$t('CONVERSATION.CUSTOM_SNOOZE.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          :label="$t('CONVERSATION.CUSTOM_SNOOZE.APPLY')"
        />
      </div>
    </form>
  </div>
</template>
